import { UserTypes } from 'utils/UserTypes'
import { NotifiableMessageTypes } from './constants'
import { hasConversationAccess } from 'app/modules/access/helpers'

function emptyMessage(message) {
  const { type, body, attachments } = message

  return type === NotifiableMessageTypes.CHAT &&
         body && body.length === 0 &&
         attachments && attachments.count() === 0
}

export function isParticipantEvent(message) {
  const { contentType, conversationEvent } = message

  return contentType === "CONVERSATION_EVENT" && !!conversationEvent.participantChangeType
}

export function isRoutingFailedEvent(message) {
  const { contentType, conversationEvent } = message
  return contentType === "CONVERSATION_EVENT" && conversationEvent.type === "ROUTING_FAILED"
}

export function isBackendGenerated(message) {
  const { authorId, conversationEvent } = message
  return (authorId === 0 && conversationEvent.type !== 'END_USER_PROPERTY_ALREADY_PRESENT')
    && !isParticipantEvent(message)
    && !isRoutingFailedEvent(message)
}

export function isEmailCaptureMessage(message) {
  return message.getIn(['attributes', 'show_email_capture_card'], false)
}

export function isEmptyGoalMessage(message) {
  return message.getIn(["attributes", "goalReached"], false) && message.get("body") === ""
}

export function isFirstBotInteractionMessage(message) {
  return message.getIn(['attributes', 'startInteraction'], false) &&
         (message.get('authorType') === UserTypes.END_USER ||
          message.get('authorType') === UserTypes.LEAD)
}

export function isEditMessage(message) {
  return message.type === 'EDIT' || message.getIn(['attributes', 'editedMessageId'], false)
}

export const isChatRating = (message) => {
  return message.type === 'CHAT_RATING'
}

export function shouldNotifyUser(message, conversation, currentUser, userProperties, hasCentralizedRouting = false) {
  if (!hasConversationAccess(conversation.participantIds, currentUser)) {
    return false
  }

  if (hasCentralizedRouting) {
    if (userProperties.get('notifications-snoozed')) {
      return false
    }
  } else {
    if (currentUser.availability === "OFFLINE") {
      return false
    }
  }

  const browserNotificationSetting = userProperties.get('humane-notifications-browser', 'nothing')
  const browserNotificationsAll = browserNotificationSetting === 'all'
  const browserNotificationsUnassigned = browserNotificationSetting === 'mine-and-unassigned'
  const browserNotificationsOnlyMine = browserNotificationSetting === 'mine'

  const isParticipant = conversation.participantIds.includes(currentUser.id)
  const isMine = message.authorType === 'USER' && currentUser.id === message.authorId
  const isNotifiableType = !!NotifiableMessageTypes[message.type]

  if (!isMine && !emptyMessage(message) && isNotifiableType) {
    if (conversation.status === "BULK_SENT") return false


    return browserNotificationsAll ||
           (browserNotificationsUnassigned && (isParticipant || !conversation.participantIds.count())) ||
           (browserNotificationsOnlyMine && isParticipant)
  }

  return false
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/message/helpers.js